import { render, staticRenderFns } from "./ImportLists.vue?vue&type=template&id=25ec3356&scoped=true&"
import script from "./ImportLists.vue?vue&type=script&lang=js&"
export * from "./ImportLists.vue?vue&type=script&lang=js&"
import style0 from "./ImportLists.vue?vue&type=style&index=0&id=25ec3356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec3356",
  null
  
)

export default component.exports